import React from 'react';

import styles from './Divider.module.css';

export function Divider(): React.ReactElement {
  return <div className={styles.divider} />;
}
